import React, { useEffect, useState, useRef, memo } from 'react';
import styles from './style.module.css';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NotificationInfo from './NotificationInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import NewSpinner from '../../../common/components/NewSpinner/NewSpinner';
import { notificationGetAPI, notificationAsReadAPI } from '../../constants/api';

const WhatsAppNotification = ({ notification, setNotification }) => {
  const { notificationContainer, top_header } = styles;
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);

  const [pageNo, setPageNo] = useState(0);
  const [loading, setLoading] = useState(false);
  const [endPage, setEndPage] = useState(0);
  const [perPageResult, setPerPageResult] = useState(50);
  const [allread, setAllRead] = useState(false);

  const loader = useRef(null);

  const getNotificationFun = () => {
    setType('loading');
    setText('Please wait while retrieving data...');
    setShow(true);
    setLoading(true);
    notificationGetAPI({
      pageNo,
      perPageResult
    })
      .then(res => {
        let existingData = data || [];
        setData([
          ...existingData,
          ...(res?._embedded?.userNotificationsResponseList || [])
        ]);
        setEndPage(res?.page?.totalPages);
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  };
  useEffect(() => {
    if (notification) {
      getNotificationFun();
    }
  }, [pageNo, notification, allread]);

  useEffect(() => {
    if (notification) {
      setPageNo(0);
    }
  }, [notification]);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 0.8
    };

    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
    return () => observer.unobserve(loader.current);
  }, [data, endPage]);

  const handleObserver = entities => {
    const target = entities[0];
    if (target.isIntersecting) {
      if (pageNo + 1 < endPage) {
        setPageNo(prev => prev + 1);
      }
    }
  };
  let isDone = parseInt(pageNo) + 1 === parseInt(endPage);

  const markAllRead = () => {
    setType('loading');
    setText('loading...');
    setShow(true);
    notificationAsReadAPI()
      .then(res => {
        setAllRead(true);
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  };
  return (
    <div>
      <div
        className={`${notificationContainer} text-black-600 `}
        style={{
          width: notification ? '' : '0px'
        }}
      >
        <div
          className={` ${top_header} flex justify-between mx-3  fixed z-10 mt-0 p-3 w-full bg-white`}
        >
          <div
            className="text-xl text-black-1011 flex items-center justify-between"
            style={{
              width: '90%'
            }}
          >
            Notification
            {data?.length !== 0 && !allread && (
              <div
                onClick={markAllRead}
                className="text-xs ml-3 cursor-pointer"
              >
                Mark all as read
              </div>
            )}
          </div>
          <div
            className="cursor-pointer w-5"
            onClick={() => {
              setNotification(false);
              setData([]);
              setEndPage(0);
              setPageNo(0);
            }}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </div>
        </div>
        {notification && data && data.length ? (
          <div className="mt-14">
            {data.map((each, i) => {
              return (
                <NotificationInfo
                  key={`${pageNo}${i}`}
                  each={each}
                  setNotification={setNotification}
                  allread={allread}
                />
              );
            })}
          </div>
        ) : (
          <div className="flex items-center justify-center text-lg mt-12">
            {' '}
            No Notification!
          </div>
        )}
        <div
          className="loading flex items-center justify-center h-14"
          ref={loader}
        >
          {!isDone && loading && data.length !== 0 && !allread && (
            <NewSpinner />
          )}
          {isDone && (
            <div className="flex items-center justify-center">
              No more data to show
            </div>
          )}
        </div>
      </div>{' '}
      <PopUp type={type} text={text} show={show} setShow={setShow} />
    </div>
  );
};
export default WhatsAppNotification;
